import { createContext, useState, useEffect, useContext } from "react";
import { auth, db_firestore } from "../firebase-configure";
import { doc, setDoc, getDoc, collection, getDocs, query, where } from "firebase/firestore";

const AuthContext = createContext();

const inicialUser = {name:'',avatar:'',cuil:'',email:''};

export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [myUser, setMyUser] = useState({inicialUser});

    const signUp = async (email, password,cuil) => {
        const querySnapshot = await getDocs(query(collection(db_firestore, "users"),where("cuil","==",cuil)));
        if (querySnapshot.docs.length !== 0) {
            console.log(querySnapshot.docs);
           // throw 'CUIL YA existe';
        }
        const u = await auth.createUserWithEmailAndPassword(email, password);
        if (u) {
            await setDoc(doc(db_firestore, "users",  u.user.uid), {
                cuil: cuil,
                email: email,
                avatar: "foto02.jpg",
            })

            const docRef = doc(db_firestore, "users", u.user.uid);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setMyUser(docSnap.data());
            }
        }
    };

    const login = async (email, password) => {
        const u = await auth.signInWithEmailAndPassword(email, password);
        if (u) {
            await getUser(u.user);
        }
    };

    const getUser = async (u)  => {
        const docRef = doc(db_firestore, "users", u.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            setMyUser(docSnap.data());
        }
    }

    const logout = () => {
        auth.signOut();
        setMyUser(inicialUser);
    }

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setCurrentUser(user);
        })
    }, []);

    const data = { signUp, login, logout, getUser, currentUser, myUser };

    return (
        <AuthContext.Provider value={data} > {children} </AuthContext.Provider>
    );
};

export { AuthProvider };
export default AuthContext;


